// extracted by mini-css-extract-plugin
module.exports = {"IkkeAutorisert":"IkkeAutorisert_IkkeAutorisert__c7kuR","ingress":"IkkeAutorisert_ingress__1_NXW"};